import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled } from '@ori-ui/mui';
import { ARTICLE_BOX_DESKTOP_WIDTH, ARTICLE_BOX_MOBILE_WIDTH } from "../ArticleBox/constants";
export var Root = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: ARTICLE_BOX_MOBILE_WIDTH
  }, theme.breakpoints.up('sm'), {
    maxWidth: ARTICLE_BOX_DESKTOP_WIDTH
  });
});
//# sourceMappingURL=styles.js.map